import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Categories from '../blocks/Categories';

class Nav extends Component {
  state = {
    showCats: false
  }
  handleCatHover = (e) => {
    if(window.outerWidth > 1024 && e.currentTarget.children.length > 1){
      this.setState({
        showCats: !this.state.showCats
      });
    }
  }
  handleClick = (e) => {
    e.preventDefault();
    if(window.outerWidth <= 1024){
      if(e.currentTarget.children.length > 1){
        this.setState({
          showCats: !this.state.showCats
        });
      }
      else {
        this.setState({
          showCats: false
        });
        this.props.handleMobileClick();
      }
      
    }
    
  }
  
  render(){
    let catClass = '';
    if(this.state.showCats){
      catClass = 'show';
    }
    return(
      <nav className="nav-main">
  
        <ul className={`main-nav ${this.props.menuClass}`}>
          <li
            onMouseLeave={this.handleCatHover}
            onMouseEnter={this.handleCatHover}
            onClick={this.handleClick}
          >
            <a href="/" className="find">
              <i className="fa fa-search" aria-hidden="true"></i> FIND
            </a>
            <Categories
              handleMobileClick={this.props.handleMobileClick}
              catClass={catClass}
            />
          </li>
          <li
            onClick={this.handleClick}
          >
            <NavLink to="/getfound" className="sign-up">
              <i className="fa fa-pencil-square" aria-hidden="true"></i> GET FOUND
            </NavLink>
          </li>

        </ul>
      </nav>
    );
  }
}
export default Nav;


// WEBPACK FOOTER //
// ./src/components/sections/Nav.js